// extracted by mini-css-extract-plugin
module.exports = {"r1cl1oku":"r1cl1oku","r1q6tptt":"r1q6tptt"};